import React, { Component } from "react"
import TableGestores from "./TableGestores"
import Layout from "../Layout"
import { Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class Gestores extends Component {
  constructor() {
    super()
    this.getGestores = this.getGestores.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { gestores: [], initialGestores: [], showTable: false }
  }
  componentWillMount() {
    this.getGestores()
  }
  getGestores() {
    ApiHelper.getGestores((gestores, error) => {
      if (gestores) {
        this.setState({
          gestores: gestores,
          initialGestores: gestores,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialGestores.filter(gestor => {
      return (
        gestor.name.toLowerCase().search(searchText) !== -1 ||
        gestor.cpf.toLowerCase().search(searchText) !== -1 ||
        gestor.email.toLowerCase().search(searchText) !== -1 ||
        gestor.portaria.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      gestores: filtered
    })
  }
  didDelete() {
    this.getGestores()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Gestores de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Gestores de contrato">
        {this.state.showTable ? (
          <TableGestores
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Gestores de contrato"
            subtitle="Listagem de todas os gestores de contrato"
            backgroundColor="as-blue"
            rows={this.state.gestores}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/gestores/Gestores.js